import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2e261f1f")
const _hoisted_1 = { class: "migration-banner-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "migration-banner"
}
const _hoisted_3 = { class: "banner-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-bell" }, null, -1)
const _hoisted_5 = { class: "text" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "学校平台迁移公告", -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "notice-hero" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "notice-icon-wrap" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "el-icon-bell" })
  ]),
  /*#__PURE__*/_createElementVNode("h3", { class: "notice-title" }, "学校平台迁移公告")
], -1)
const _hoisted_10 = { class: "notice-body" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "notice-time-card"
}
const _hoisted_13 = { class: "time-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "time-tag" }, "迁移窗口", -1)
const _hoisted_15 = { class: "time-range" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("em", null, "至", -1)
const _hoisted_17 = {
  key: 0,
  class: "time-countdown"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-time" }, null, -1)
const _hoisted_19 = { class: "notice-actions" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("我知道了")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", {
                class: "notice-html",
                innerHTML: _ctx.noticeHtmlInline
              }, null, 8, _hoisted_7),
              (_ctx.cutoverStart > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" 迁移窗口 " + _toDisplayString(_ctx.formatTime(_ctx.cutoverStart)) + " 至 " + _toDisplayString(_ctx.formatTime(_ctx.cutoverEnd)) + "。 ", 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.countdown)
                ? (_openBlock(), _createElementBlock("em", _hoisted_8, "距停服还有 " + _toDisplayString(_ctx.countdown), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("i", {
            class: "el-icon-close close-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = $event)),
      width: "480px",
      "custom-class": "migration-notice-dialog",
      "show-close": false,
      "close-on-click-modal": false,
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "notice-text",
            innerHTML: _ctx.noticeHtml
          }, null, 8, _hoisted_11),
          (_ctx.cutoverStart > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("span", _hoisted_15, [
                    _createTextVNode(_toDisplayString(_ctx.formatTime(_ctx.cutoverStart)) + " ", 1),
                    _hoisted_16,
                    _createTextVNode(" " + _toDisplayString(_ctx.formatTime(_ctx.cutoverEnd)), 1)
                  ])
                ]),
                (_ctx.countdown)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createTextVNode(" 距停服还有 " + _toDisplayString(_ctx.countdown), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_button, {
            type: "primary",
            round: "",
            onClick: _ctx.closeNoticeDialog
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}